(function() {
  'use strict';

  const TIPO = {
    widget: '.ga-products-box',
    productCard: '.ga-products-input .ga-product',
    priceEl: '.ga-product_price',
    productLink: 'a.ga-product_title',
    totalEl: '.ga-product_totalprice',
    totalSaleEl: '.ga-product_total_sale_price',
    checkbox: 'input.selectedItem'
  };

  function getLocaleRoot() {
    const shopifyRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (shopifyRoot && shopifyRoot !== '/') return shopifyRoot.endsWith('/') ? shopifyRoot : shopifyRoot + '/';
    const pathMatch = window.location.pathname.match(/^(\/[a-z]{2}(?:-[a-z]{2})?\/)/i);
    if (pathMatch) return pathMatch[1];
    return '/';
  }

  function getActiveCurrency() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    const active = document.querySelector('#currencies .active[data-currency]');
    if (active) return active.getAttribute('data-currency');
    if (typeof window.Currency !== 'undefined' && window.Currency.currentCurrency) {
      return window.Currency.currentCurrency;
    }
    return '';
  }

  const priceCache = new Map();

  async function fetchCorrectPrice(handle) {
    // Key and fetch per active currency: a price cached/served for a previous
    // currency must never be reused, so the block always shows the selected
    // currency's price as soon as it appears (no reload needed).
    const currency = getActiveCurrency();
    const cacheKey = handle + '|' + currency;
    if (priceCache.has(cacheKey)) return priceCache.get(cacheKey);
    const root = getLocaleRoot();
    let url = `${root}products/${encodeURIComponent(handle)}?section_id=fbp-price-fix`;
    if (currency) url += `&currency=${encodeURIComponent(currency)}`;
    try {
      const res = await fetch(url, { headers: { 'Accept': 'text/html' }, credentials: 'same-origin' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const html = await res.text();
      const match = html.match(/<script type="application\/json" data-fbp-price>([\s\S]*?)<\/script>/);
      if (!match) throw new Error('No price data in response');
      const data = JSON.parse(match[1]);
      priceCache.set(cacheKey, data);
      return data;
    } catch (err) {
      return null;
    }
  }

  function extractHandle(item) {
    const link = item.querySelector(TIPO.productLink);
    if (!link) return null;
    const m = link.getAttribute('href').match(/\/products\/([^?#/]+)/);
    return m ? m[1] : null;
  }

  async function fixItem(item) {
    const priceEl = item.querySelector(TIPO.priceEl);
    if (!priceEl || priceEl.hasAttribute('data-tipo-fixed')) return;
    const handle = extractHandle(item);
    if (!handle) return;
    const data = await fetchCorrectPrice(handle);
    if (!data || !data.price) return;
    const correct = data.price;
    priceEl.textContent = correct;
    priceEl.setAttribute('data-tipo-fixed', 'true');
    if (data.price_cents != null) priceEl.setAttribute('data-tipo-cents', data.price_cents);
    priceEl.classList.remove('money');

    // The Tipo app re-renders prices in the shop's default currency after we
    // set them. Re-apply the active-currency value whenever it gets overwritten
    // so the selected currency price is what stays on screen, and refresh the
    // total from the (unchanged) cents so it stays in the active currency too.
    let restores = 0;
    const lockObs = new MutationObserver(function() {
      if (restores >= 30) { lockObs.disconnect(); return; }
      if (priceEl.textContent !== correct) {
        restores++;
        priceEl.textContent = correct;
        if (data.price_cents != null) priceEl.setAttribute('data-tipo-cents', data.price_cents);
        priceEl.classList.remove('money');
        const widget = item.closest(TIPO.widget);
        if (widget) recalcTotal(widget);
      }
    });
    lockObs.observe(priceEl, { childList: true, characterData: true, subtree: true });
    setTimeout(function() { lockObs.disconnect(); }, 10000);
  }

  // Format an amount in cents using Shopify's money formatter so the symbol,
  // decimal places and thousands separator follow the active currency's rules.
  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      const s = window.Shopify.formatMoney(cents, window.money_format);
      // money_format may wrap the value in <span class="money">…</span>; strip
      // it so the plain formatted amount is shown (matches the per-item prices).
      return s == null ? null : String(s).replace(/<[^>]*>/g, '').trim();
    }
    return null;
  }

  // Work out the exact formatting of an item's price string (e.g. "3.600 kr",
  // "$1,234.56", "1 234,56 €") from its known cents value. Nothing is
  // hardcoded: the symbol, thousands separator, decimal separator and decimal
  // count are all read straight from the rendered item price, so the total can
  // be formatted identically for whatever currency is selected.
  function derivePattern(text, cents) {
    if (text == null || cents == null || isNaN(cents)) return null;
    const first = text.search(/\d/);
    if (first < 0) return null;
    let last = -1;
    for (let i = text.length - 1; i >= 0; i--) { if (/\d/.test(text[i])) { last = i; break; } }
    const numeric = text.slice(first, last + 1);
    const prefix = text.slice(0, first);
    const suffix = text.slice(last + 1);
    const digits = numeric.replace(/\D/g, '');
    const abs = Math.abs(cents);

    // Use the known cents to tell decimals apart from grouping unambiguously.
    let decimals;
    if (digits === String(abs)) decimals = 2;            // e.g. 7285 -> "72,85"
    else if (digits === String(Math.round(abs / 100))) decimals = 0; // 360000 -> "3.600"
    else decimals = (abs % 100 === 0) ? 0 : 2;

    const seps = [];
    for (const ch of numeric) { if (!/\d/.test(ch)) seps.push(ch); }
    let decimalSep = '', thousandsSep = '';
    if (decimals > 0) {
      decimalSep = seps.length ? seps[seps.length - 1] : '';
      for (const s of seps) { if (s !== decimalSep) { thousandsSep = s; break; } }
    } else {
      thousandsSep = seps.length ? seps[0] : '';
    }
    return { prefix: prefix, suffix: suffix, decimals: decimals, decimalSep: decimalSep, thousandsSep: thousandsSep };
  }

  // Format cents using a pattern derived from the item prices, so the total
  // matches them exactly (symbol, separators, decimals) in every currency.
  function formatWithPattern(cents, p) {
    const neg = cents < 0;
    const abs = Math.abs(cents);
    let intStr, fracStr = '';
    if (p.decimals > 0) {
      intStr = String(Math.floor(abs / 100));
      fracStr = String(abs % 100).padStart(2, '0');
    } else {
      intStr = String(Math.round(abs / 100));
    }
    if (p.thousandsSep) {
      intStr = intStr.replace(/\B(?=(\d{3})+(?!\d))/g, p.thousandsSep);
    }
    let num = intStr;
    if (p.decimals > 0) num += p.decimalSep + fracStr;
    return (neg ? '-' : '') + p.prefix + num + p.suffix;
  }

  // Set an element's text to the active-currency value and keep it there: the
  // Tipo app may rewrite it in the default currency, so re-apply on overwrite.
  function setLocked(el, value) {
    el.setAttribute('data-tipo-want', value);
    if (el.textContent !== value) el.textContent = value;
    el.setAttribute('data-tipo-fixed', 'true');
    el.classList.remove('money');
    if (el.hasAttribute('data-tipo-locked')) return;
    el.setAttribute('data-tipo-locked', 'true');
    let restores = 0;
    const obs = new MutationObserver(function() {
      if (restores >= 60) { obs.disconnect(); return; }
      const want = el.getAttribute('data-tipo-want');
      if (want != null && el.textContent !== want) {
        restores++;
        el.textContent = want;
      }
    });
    obs.observe(el, { childList: true, characterData: true, subtree: true });
  }

  function recalcTotal(widget) {
    const totalEl = widget.querySelector(TIPO.totalEl);
    if (!totalEl) return;

    // Sum every selected item in cents, then format once. Keep one item's
    // rendered price + cents as a reference so the total is formatted in the
    // exact same way as the items for the currently selected currency.
    let sumCents = 0;
    let allFixed = true;
    let refText = null, refCents = null;
    widget.querySelectorAll(TIPO.productCard).forEach(item => {
      const cb = item.querySelector(TIPO.checkbox);
      if (cb && !cb.checked) return;
      const priceEl = item.querySelector(TIPO.priceEl);
      if (!priceEl) return;
      if (!priceEl.hasAttribute('data-tipo-fixed')) { allFixed = false; return; }
      const cents = parseInt(priceEl.getAttribute('data-tipo-cents'), 10);
      if (!isNaN(cents)) {
        sumCents += cents;
        if (refText === null) { refText = priceEl.textContent.trim(); refCents = cents; }
      }
    });
    if (!allFixed) return;

    // Format only after the total is calculated, matching the item prices.
    const pattern = derivePattern(refText, refCents);
    const newText = pattern ? formatWithPattern(sumCents, pattern) : formatMoney(sumCents);
    if (newText === null) return;

    setLocked(totalEl, newText);

    const saleEl = widget.querySelector(TIPO.totalSaleEl);
    if (saleEl) {
      setLocked(saleEl, newText);
    }
  }

  async function fixWidget(widget) {
    const items = widget.querySelectorAll(TIPO.productCard);
    await Promise.all(Array.from(items).map(fixItem));
    recalcTotal(widget);

    widget.querySelectorAll(TIPO.checkbox).forEach(cb => {
      if (cb.hasAttribute('data-tipo-bound')) return;
      cb.setAttribute('data-tipo-bound', 'true');
      cb.addEventListener('change', () => {
        setTimeout(() => recalcTotal(widget), 0);
      });
    });
  }

  function scan() {
    document.querySelectorAll(TIPO.widget).forEach(fixWidget);
  }

  const observer = new MutationObserver(() => {
    if (document.querySelector(TIPO.widget)) scan();
  });

  function init() {
    scan();
    observer.observe(document.body, { childList: true, subtree: true });
    [500, 1500, 3000, 5000].forEach(ms => setTimeout(scan, ms));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
